export function getUniqueKey(name, obj) {
    var unique = name;
    var no = 1;
    while (unique in obj) {
        unique = name + "_" + no;
        no++;
    }
    return unique;
}
export default getUniqueKey;

//# sourceMappingURL=getUniqueKey.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/reassemble/lib/utils/getUniqueKey.js
// module id = 184
// module chunks = 0